import { s__ } from '~/locale';
import { findStatusWidget } from '~/work_items/utils';
import { sortStatuses } from 'ee/work_items/utils';
import getBoardNamespaceStatusesQuery from '../graphql/get_namespace_statuses.query.graphql';

// Status grouping is EE-only (statuses don't exist in CE), so grouping by
// status in CE resolves to no strategy.
/** @type {import('~/work_items/board/grouping/index').GroupingStrategy} */
export const statusStrategy = {
  property: 'status',

  label: s__('WorkItems|Status'),

  valuesQuery: getBoardNamespaceStatusesQuery,

  // Sort columns by category (triage, to_do, in_progress, done, cancelled) for a
  // consistent order rather than the order the API returns them in.
  extractValues(data) {
    return sortStatuses(data?.namespace?.rootNamespace?.statuses?.nodes ?? []);
  },

  columnFilter(value) {
    return { status: { name: value.name } };
  },

  moveInput(value) {
    return { statusWidget: { status: value.id } };
  },

  patchCard(node, value) {
    const statusWidget = findStatusWidget(node);
    if (statusWidget) {
      // Leading spread preserves any status fields the column value omits.
      statusWidget.status = { ...statusWidget.status, ...value };
    }
  },

  headerDecoration(value) {
    return value.iconName
      ? { type: 'icon', name: value.iconName, color: value.color }
      : { type: 'none' };
  },
};
